import { faEnvelope, faGraduationCap } from "@fortawesome/free-solid-svg-icons"
import {
  faGithub,
  faLinkedinIn,
  faResearchgate,
  faGoodreadsG,
} from "@fortawesome/free-brands-svg-icons"

const socials = [
  {
    name: "Email",
    href: "mailto:simonrose121@gmail.com",
    icon: faEnvelope,
  },
  {
    name: "Github",
    href: "https://github.com/simonrose121",
    icon: faGithub,
  },
  {
    name: "LinkedIn",
    href: "http://uk.linkedin.com/in/simonprose/",
    icon: faLinkedinIn,
  },
  {
    name: "Google Scholar",
    href: "https://scholar.google.com/citations?user=wMWa2TkAAAAJ&hl=en",
    icon: faGraduationCap,
  },
  {
    name: "Research Gate",
    href: "https://www.researchgate.net/profile/Simon_Rose2",
    icon: faResearchgate,
  },
  {
    name: "Goodreads",
    href: "https://www.goodreads.com/user/show/22312452-simon-rose",
    icon: faGoodreadsG,
  },
]

export default socials
